<template>
  <v-app id="app">
    <div v-if="!this.$route.meta.HideHeader">
      <app-header />
      <app-layout />
    </div>
    <div class="fill-height" v-else>
      <v-content>
        <router-view />
      </v-content>
    </div>
    <app-footer v-if="!this.$route.meta.guest"/>
  </v-app>
</template>


<script>
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import Layout from "./Layout";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "app-layout": Layout,
  },

  methods: {
    async getApiUrlHandler() {
      // if (process.env.NODE_ENV === "development") {
      //   this.$store.dispatch("retrvDevApi").catch((error) => {
      //     console.log(error);
      //   });
      // } else {
      //   this.$store.dispatch("retrvProdApi").catch((error) => {
      //     console.log(error);
      //   });
      // }
      try {
        if (process.env.NODE_ENV === "development") {
          await this.$store.dispatch("retrvDevApi");
        } else {
          await this.$store.dispatch("retrvProdApi");
        }
        // Emit event when API is ready
        this.$root.$emit('api-ready');
      } catch (error) {
        console.log(error);
      }
    },
    checkislogin() {
      if (typeof this.$session.get("access_token") == "undefined") {
        // this.$store.dispatch("deleteToken");
        // this.$router.replace("/" + this.$i18n.locale + "/login");
      }
    },
    resetTokenHandler() {
      this.$store.dispatch("deleteToken");
    },

    async getFileUploadConfig() {
      // this.$store.dispatch("retriveFileUploadConfig").catch((error) => {
      //   console.log(error);
      // });
      try {
        await this.$store.dispatch("retriveFileUploadConfig");
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    await this.getApiUrlHandler();
    await this.getFileUploadConfig();
    // this.checkislogin();
    //this.resetTokenHandler();
  },
};
</script>
